import $ from 'jquery';

export const loadSelectOrientation = () => {
  $('#formats-select-orientation').select2({
    tags: false,
    allowClear: false,
    width: '100%',
    theme: 'bootstrap4',
    placeholder: {
      text: 'Seleziona orientamento',
    },
  });

  $('#formats-select-orientation').select2('val', '0');
};
